var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":"","justify-center":"","pt-10":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('v-img',{attrs:{"contain":"","src":require("../assets/Images/Picture4.png")}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }